<div class="header">
  <div class="icon">JV</div>
  <div class="info">
    <slot />
  </div>
</div>

<style>
  .header {
    display: flex;
    width: 100%;
    color: #333;
    gap: 16px;
    height: 55px;
  }
  .header .icon {
    font-family: "Cormorant Garamond", serif;
    font-size: 30px;
    padding: 8px;
    padding-left: 16px;
  }
  .header .info {
    font-weight: 300;
    padding: 16px;
    display: flex;
    flex-grow: 1;
    align-items: center;
  }
</style>
